import { render, staticRenderFns } from "./ProjectBody.vue?vue&type=template&id=40a09f1c&lang=pug&"
import script from "./ProjectBody.vue?vue&type=script&lang=js&"
export * from "./ProjectBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports